// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__34YaV","tab":"ProcedureTabs_tab__1a3Rp"};